import moment from 'moment/moment';

import { Currency } from 'types/general.types';

const currencyLocaleMap: { [key in Currency]: string } = {
  [Currency.USD]: 'en-US',
  [Currency.GBP]: 'en-US',
  [Currency.EUR]: 'de-DE',
  [Currency.BTC]: 'en-US',
};

export const formatCurrency = (currency: Currency, amount: number): string => {
  const locale = currencyLocaleMap[currency];

  /* eslint-disable @typescript-eslint/no-magic-numbers */
  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: currency === Currency.BTC ? 10 : 2,
  }).format(amount);

  if (currency === Currency.BTC) {
    return `${formatted.split('BTC').join('')}`;
  }

  return formatted;
};

type FormatDateOptions = { format?: string; forInput?: boolean };

export const formatDate = (
  date: Date | string,
  { format = 'DD/MM/YYYY', forInput = false }: FormatDateOptions = {},
) => {
  if (!date) return '';

  const m = moment(date, [moment.ISO_8601, 'DD/MM/YYYY', 'D/M/YYYY', 'M/D/YYYY'], true);

  if (!m.isValid()) return '';

  if (forInput) return m.format('YYYY-MM-DD');

  return m.format(format);
};
